import Clarity from "@microsoft/clarity";

// Master switch for the whole Clarity integration. Flip to true when
// it needs to be integrated.
const CLARITY_ENABLED = false;

// Flip to true once the client confirms Clarity recording itself must wait for
// explicit GDPR opt-in, instead of running like GA's always-on analytics_storage.
const REQUIRE_EXPLICIT_CONSENT = true;

const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

let initialized = false;

const applyConsent = (hasGdprConsent: boolean) => {
  Clarity.consentV2({
    ad_Storage: hasGdprConsent ? "granted" : "denied",
    analytics_Storage:
      !REQUIRE_EXPLICIT_CONSENT || hasGdprConsent ? "granted" : "denied",
  });
};

// Call once on app bootstrap. hasGdprConsent reflects the visitor's stored
// GdprConsent choice so the very first session already respects it.
export const initClarity = (hasGdprConsent: boolean) => {
  if (!CLARITY_ENABLED || initialized || !projectId) {
    return;
  }
  Clarity.init(projectId);
  initialized = true;
  applyConsent(hasGdprConsent);
};

// Call whenever GdprConsent's hasGdprConsent value changes.
export const updateClarityConsent = (hasGdprConsent: boolean) => {
  if (!CLARITY_ENABLED || !initialized) {
    return;
  }
  applyConsent(hasGdprConsent);
};

export const setClarityTag = (key: string, value: string | string[]) => {
  if (!CLARITY_ENABLED || !initialized) {
    return;
  }
  Clarity.setTag(key, value);
};

export const clarityEvent = (eventName: string) => {
  if (!CLARITY_ENABLED || !initialized) {
    return;
  }
  Clarity.event(eventName);
};

// Prioritizes the session for recording, e.g. for high-value interactions.
export const upgradeClaritySession = (reason: string) => {
  if (!CLARITY_ENABLED || !initialized) {
    return;
  }
  Clarity.upgrade(reason);
};
